import { RETRIEVAL_GUARDIAN_CONFIG } from "../guardianFormConfig";
import { createUpdateGuardianAt } from "./useGuardianFormGuardianPatch";
import { createPgHandlers } from "./useGuardianFormPgHandlers";
import { createAttorneyHandlers } from "./useGuardianFormAttorneyHandlers";
import { createAddressAndFieldHandlers } from "./useGuardianFormAddressHandlers";

/**
 * Bond Retrieval guardian handlers — façade over patch / PG / attorney / address modules (Phase 4).
 *
 * @param {object} opts
 * @param {string} opts.bondKind
 * @param {{ guardians?: unknown[] }} opts.data
 * @param {(p: object) => void} opts.updateData
 * @param {unknown[]} opts.attorneys
 * @param {React.MutableRefObject<unknown>} opts.dataRef
 * @param {(a: string, b: string) => string} [opts.joinEmploymentOccupation]
 */
export function useGuardianFormHandlers({
  bondKind,
  data,
  updateData,
  attorneys,
  dataRef,
  joinEmploymentOccupation,
}) {
  const cfg = RETRIEVAL_GUARDIAN_CONFIG[bondKind];
  const keys = cfg.fieldKeys;
  const updateGuardianAt = createUpdateGuardianAt({ data, updateData });

  const pg = createPgHandlers({
    bondKind,
    keys,
    cfg,
    dataRef,
    updateData,
    updateGuardianAt,
  });

  const attorney = createAttorneyHandlers({
    bondKind,
    keys,
    data,
    updateData,
    attorneys,
    updateGuardianAt,
  });

  const address = createAddressAndFieldHandlers({
    bondKind,
    keys,
    data,
    updateData,
    dataRef,
    joinEmploymentOccupation,
  });

  return {
    updateGuardianAt,
    ...pg,
    ...attorney,
    ...address,
  };
}
